import React from 'react';

import { IonItemOption } from '@ionic/react';

import { SelectPicker } from 'components/Select';

import {
  useCreatePreset,
  useRemovePreset,
  useRenamePreset,
  useUpdatePreset,
} from './data';
import { Preset } from './interfaces';

export const titleFilter = (opt: any, query: string) => {
  const optLabel = opt.title;

  if (!query) {
    return true;
  }
  return optLabel.toLowerCase().includes(query.trim().toLowerCase());
};

const PresetPicker: React.FC<any> = ({
  screenKey,
  activePresetId,
  onSubmit,
  onApply,
  getLabel,
  getBadge,
  data,
  state,
  onClose,
}) => {
  const [createPreset] = useCreatePreset(screenKey);
  const [updatePreset] = useUpdatePreset(screenKey);
  const [renamePreset] = useRenamePreset(screenKey);
  const [removePreset] = useRemovePreset(screenKey);

  const reset = (p: Preset) => onSubmit(p);
  const update = async (p: Preset) => {
    const preset = await updatePreset(p, state);
    onSubmit(preset);
  };
  const rename = async (p: Preset) => {
    await renamePreset(p);
  };
  const remove = async (p: Preset) => {
    await removePreset(p);
  };
  const add = async () => {
    const newPreset = await createPreset(state);
    onApply(newPreset);
  };

  const handleSelect = (presetId: any) => {
    const preset = (data as any[]).find(p => p.id === presetId);
    if (presetId !== activePresetId) {
      onSubmit(preset);
    }
  };

  // @ts-ignore
  return (
    <SelectPicker
      add={true}
      onClose={onClose}
      multiple={false}
      onSubmit={handleSelect}
      data={data as any[]}
      title={'Presets'}
      value={activePresetId}
      getLabel={getLabel}
      getBadge={getBadge}
      onAdd={add}
      addText={'Add preset'}
      filter={titleFilter}
      primaryActions={(p: any, meta: any) => {
        return meta.selected && !!getBadge(p) ? (
          <>
            <IonItemOption color={'success'} onClick={() => update(p)}>
              Update
            </IonItemOption>
            <IonItemOption color={'secondary'} onClick={() => reset(p)}>
              Reset
            </IonItemOption>
          </>
        ) : null;
      }}
      secondaryActions={(p: any) => (
        <>
          <IonItemOption color={'tertiary'} onClick={() => rename(p)}>
            Rename
          </IonItemOption>
          <IonItemOption color={'danger'} onClick={() => remove(p)}>
            Delete
          </IonItemOption>
        </>
      )}
    />
  );
};

export default PresetPicker;
